import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import EMPStatusTab from "../EMPStatusTab/EMPStatusTab";

const proximaRegularFontFamily =
  '"ProximaNovaRegular", "Lincoln Proxima Nova", Arial, sans-serif';

const proximaSemiboldFontFamily =
  '"ProximaNovaSemibold", "Lincoln Proxima Nova Semibold", Arial, sans-serif';

const titleSx = {
  color: "var(--color-text-onlight-moderate-default, #333)",
  fontFamily: proximaSemiboldFontFamily,
  fontSize: "var(--body-1-semibold-font-size, 16px)",
  fontStyle: "normal",
  fontWeight: "var(--body-1-semibold-font-weight, 600)",
  lineHeight: "var(--body-1-semibold-line-height, 24px)",
};

const descriptionSx = {
  color: "var(--color-text-onlight-moderate-default, #333)",
  fontFamily: proximaRegularFontFamily,
  fontSize: "var(--body-1-regular-font-size, 16px)",
  fontStyle: "normal",
  fontWeight: "var(--body-1-regular-font-weight, 400)",
  lineHeight: "var(--body-1-regular-line-height, 24px)",
};

const ScrollableItemList = ({
  items,
  onItemClick,
  selectedItem,
  maxHeight = "600px",
}) => {
  return (
    <Box sx={{ width: "100%", maxWidth: "408px" }}>
      <Box
        sx={{
          maxHeight,
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          overflowY: "auto",
          overflowX: "hidden",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {items?.map((item) => {
          const chipLabel = item?.statusLabel || item?.actionLabel;
          const chipColor =
            item?.statusColor || item?.actionLabelColor || "warning";
          const hasStatus =
            item?.hasStatus ?? (item?.showActionLabel !== false && !!chipLabel);

          return (
            <EMPStatusTab
              key={item?.id}
              id={item?.id}
              title={item?.title}
              description={item?.description}
              hasStatus={hasStatus}
              customChipLabel={chipLabel}
              customChipLabelColor={chipColor}
              isActive={selectedItem === item?.id}
              disabled={item?.disabled ?? false}
              onClick={(id) => onItemClick?.(id)}
              titleSx={titleSx}
              descriptionSx={descriptionSx}
            />
          );
        })}
      </Box>
    </Box>
  );
};

ScrollableItemList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
      description: PropTypes.string,
      hasStatus: PropTypes.bool,
      statusLabel: PropTypes.string,
      statusColor: PropTypes.string,
      showActionLabel: PropTypes.bool,
      actionLabel: PropTypes.string,
      actionLabelColor: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ),
  onItemClick: PropTypes.func,
  selectedItem: PropTypes.string,
  maxHeight: PropTypes.string,
};

export default ScrollableItemList;
